import styled from 'styled-components';
import {Assign} from 'utility-types';

// TYPES
import {ThemeProps} from 'styled-components';

// COMPONENTS
import {Link} from 'react-router-dom';

// THEME
import {Theme} from '../../../../../stories/theme/types';

import {listItemSEOProps} from './Breadcrumb';


export const ArrowWrapper = styled.span(
  props => `
    font-size: ${props.theme.font.base};
    padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.small.s5};
  `,
);

export const OuterWrapperDiv = styled.section(
  props => `
    width: 100%;
    display: flex;
    padding-bottom: ${props.theme.spacing.large.l20};
  `,
);

export const BreadCrumbContainer = styled.div(
  props => `
      width: 100%;
      display: flex;
      align-items: center;  
  `
);

export const BreadCrumbList = styled.ol`
  list-style-type: none;
  display: flex;
  align-items: center;
`;

export const BreadCrumbItemLink = styled(Link)(
  props => `
  display: flex;
  cursor: pointer;
  font-size:${props.theme.font.base};
  text-decoration: none;
  color: ${props.theme.colors.blue.base}
  &:hover{
    color: ${props.theme.colors.blue.base}
  }
  &:visited{
    color: ${props.theme.colors.blue.base}
  }
  &.active{
    color: ${props.theme.colors.white.base}
  }
`,
);

export const BreadCrumbItemAnchorTag = styled.a(
  props => `
  display: flex;
  cursor: pointer;
  font-size:${props.theme.font.base};
  text-decoration: none;
  color: ${props.theme.colors.blue.base}
  &:hover{
    color: ${props.theme.colors.blue.base}
  }
  &:visited{
    color: ${props.theme.colors.blue.base}
  }
  &.active{
    color: ${props.theme.colors.white.base}
  }
`,
);

export const BreadCrumbATagItemLink = styled.a(
  props => `
  display: flex;
  cursor: pointer;
  font-size:${props.theme.font.base};
  text-decoration: none;
  color: ${props.theme.colors.blue.base}
  &:hover{
    color: ${props.theme.colors.blue.base}
  }
  &:visited{
    color: ${props.theme.colors.blue.base}
  }
  &.active{
    color: ${props.theme.colors.white.base}
  }
`,
);

export const NoLinkBreadcrumbListItem = styled.li(
  (props: Assign<ThemeProps<Theme>, typeof listItemSEOProps>) => `
  font-size: ${props.theme.font.base};
  color: ${props.theme.colors.grey.base};  
  font-weight: ${props.theme.font.fontWeight.bold};
`,
);
